import { allMovies } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

const releases = allMovies
  .filter((movie) => movie.cinemaStatus === '院线在映')
  .sort((a, b) => (a.releaseDate < b.releaseDate ? 1 : -1));

export default function NewReleases() {
  return (
    <section id="new" className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="新片上映"
          title="新片上映：正在影院开画的六部新作"
          desc="这里列出近期正式上映、当前仍在影院排片中的作品，含上映日期、类型与时长，方便你按时间先后挑选刚开画的新片。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {releases.map((movie) => (
            <article
              key={movie.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-56 w-full overflow-hidden sm:h-60">
                <img
                  src={movie.poster}
                  alt={`${movie.title} 海报`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-600 px-2.5 py-0.5 text-[11px] font-medium text-background-50">
                  {movie.badge}
                </span>
                <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-0.5 text-[11px] font-medium text-foreground-900">
                  <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
                  {movie.score.toFixed(1)}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{movie.title}</h3>
                  <span className="shrink-0 text-xs text-foreground-500">{movie.runtime}</span>
                </div>
                <p className="mt-1 text-xs text-foreground-600">
                  {movie.origin} · {movie.region}
                </p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {movie.genres.map((genre) => (
                    <span key={genre} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {genre}
                    </span>
                  ))}
                </div>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{movie.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line text-sm" aria-hidden="true"></i>
                    {movie.releaseDate} 上映
                  </span>
                  <span className="flex items-center gap-1 text-primary-700">
                    <i className="ri-checkbox-circle-line text-sm" aria-hidden="true"></i>
                    影院可看
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}